import React, { useState, useEffect, useContext } from "react";
import { Context } from "../../redux/store";
import { actionTypes } from "../../redux/reducer";
import { Link } from "gatsby";
import Nav from "./nav";
import ExternalLink from "../external-link";
import { useSiteMetadata } from "../../hooks/use-site-metadata";
import { getWidth } from "../../libs/utils";
import brandLogo from "../../images/logos/logo.svg";

function Header() {
  const { externalLinkInfo } = useSiteMetadata();
  const { dailymedLinkInfo } = useSiteMetadata();
  const { state, dispatch } = useContext(Context);
  const [width, setWidth] = useState(getWidth());

  // resize event listener
  useEffect(() => {
    const resizeListener = () => {
      // change width from the state object
      setWidth(getWidth());
    };
    // set resize listener
    window.addEventListener("resize", resizeListener);

    // clean up function
    return () => {
      // remove resize listener
      window.removeEventListener("resize", resizeListener);
    };
  }, []);
  return (
    <header className="content-container">
      <div className="centered-content">
        {width > 846 && (
          <div className="utility-nav-block pat-utility-nav">
            <div className="nav-list">
            <ExternalLink
                externalURL="https://www.opioidanalgesicrems.com/home.html"
                messageTitle={externalLinkInfo.TITLE}
                messageBody={externalLinkInfo.BODY}
                classNameLink={externalLinkInfo.LINK_CLASS_NAME}
                classNameOverlay={externalLinkInfo.OVERLAY_CLASS_NAME}
              >Opioid Analgesic REMS</ExternalLink>
              <ExternalLink
                externalURL="https://dailymed.nlm.nih.gov/dailymed/fda/fdaDrugXsl.cfm?setid=b7d23ac2-e776-9f62-3290-c64c2d6eb353&type=display"
                messageTitle={dailymedLinkInfo.TITLE}
                messageBody={externalLinkInfo.BODY}
                classNameLink={externalLinkInfo.LINK_CLASS_NAME}
                classNameOverlay={externalLinkInfo.OVERLAY_CLASS_NAME}
              >Full Prescribing Information</ExternalLink>
              <ExternalLink
                externalURL="https://dailymed.nlm.nih.gov/dailymed/fda/fdaDrugXsl.cfm?setid=b7d23ac2-e776-9f62-3290-c64c2d6eb353&type=display#section-17"
                messageTitle={dailymedLinkInfo.TITLE}
                messageBody={externalLinkInfo.BODY}
                classNameLink={externalLinkInfo.LINK_CLASS_NAME}
                classNameOverlay={externalLinkInfo.OVERLAY_CLASS_NAME}
              >Medication Guide</ExternalLink>
      </div>
          </div>
        )}
        <div className="logo-container">
          <Link to="/" className="logo">
            <img src={brandLogo} alt="Hysingla Brand Logo" />
          </Link>
        </div>
        <Nav />
      </div>
      {width <= 846 && (
        <div className="mobile-utility-navbar">
          <div className="mobile-utility-nav-container">
          <ExternalLink
              externalURL="https://www.opioidanalgesicrems.com/home.html"
              messageTitle={externalLinkInfo.TITLE}
              messageBody={externalLinkInfo.BODY}
              classNameLink={externalLinkInfo.LINK_CLASS_NAME}
              classNameOverlay={externalLinkInfo.OVERLAY_CLASS_NAME}
            >
              Opioid Analgesic <br />REMS
            </ExternalLink>
          <Link
                to="/safety"
                onClick={() => {
                    dispatch({
                    type: actionTypes.SET_HAMBURGER_MENU,
                    payload: false,
                    });
                }}
                className="mobile-utility-nav-link" // Add a class if needed for styling
                >
                Indication &amp; Important
                <br />
                Safety Information
            </Link>

            <ExternalLink
              externalURL="https://dailymed.nlm.nih.gov/dailymed/fda/fdaDrugXsl.cfm?setid=b7d23ac2-e776-9f62-3290-c64c2d6eb353&type=display"
              messageTitle={dailymedLinkInfo.TITLE}
              messageBody={externalLinkInfo.BODY}
              classNameLink={externalLinkInfo.LINK_CLASS_NAME}
              classNameOverlay={externalLinkInfo.OVERLAY_CLASS_NAME}
            >
              Full Prescribing
              <br />
              Information
            </ExternalLink>
          </div>
        </div>
      )}
    </header>
  );
}

export default Header;
